import { gql } from '@apollo/client';
const AUTOCOMPLETE_PRODUCT_LABELS = gql `
  query ProductLabels {
    autocomplete {
      id
      productLabels {
        id
        attributeType
        category
        attributeLabelPL
        attributeLabelEN
      }
    }
  }
`;
export default AUTOCOMPLETE_PRODUCT_LABELS;
